import { Dialog, DialogContent } from "@/components/ui/dialog"
import { cn } from "@/lib/utils"
import { getModelIconAndName } from "@/components/shared/model-info"
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

interface MessageDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  role: string
  model: string | null
  content: string
}

export function MessageDialog({
  open,
  onOpenChange,
  role,
  model,
  content,
}: MessageDialogProps) {
  const { icon, name: modelName } = getModelIconAndName(model || '')
  const displayName = role === 'user' ? 'You' : modelName

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <div className="flex flex-col space-y-4">
          <div className="flex items-center gap-2">
            <div className="h-5 w-5">
              {icon}
            </div>
            <span className="text-sm font-medium">
              {displayName}
            </span>
          </div>
          <div className={cn(
            "prose prose-sm dark:prose-invert max-w-none",
            "prose-pre:bg-muted prose-pre:border prose-pre:border-border",
            "prose-code:bg-muted prose-code:text-muted-foreground prose-code:before:content-none prose-code:after:content-none"
          )}>
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              className="break-words whitespace-pre-wrap leading-relaxed"
            >
              {content}
            </ReactMarkdown>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
